import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { OrderService } from '../../services/order.service';
import { AlertService } from '../../alert';

@Component({
  selector: 'app-events',
  providers: [OrderService],
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {

  loading = false;
  events: any [] = [];
  reference: string;

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private orderService: OrderService,
      private alertService: AlertService) {
  }

  ngOnInit() {
    this.reference = this.route.snapshot.params['id'];
    this.getOrderEvents(this.reference);
  }

  getOrderEvents(reference: string) {
    this.orderService.getOrderEvents(reference)
      .subscribe(
      data => {
        this.events = data;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

  goBack() {
      this.router.navigate(['/order', '' + this.reference]);
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/events/events.component.ts